var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.has_team_store
    ? _c(
        "div",
        [
          _c("div", { staticClass: "match-info-head-wrap" }, [
            _c(
              "h1",
              { staticClass: "head-title", attrs: { itemprop: "headline" } },
              [_vm._v(_vm._s(_vm.generateHeadline()))]
            ),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.generateDesc()))]),
          ]),
          _vm._v(" "),
          _vm.current_match && _vm.current_match.show_lineup
            ? _c("lineup-listing", {
                attrs: { togglePlayerPopup: _vm.togglePlayerPopup },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.custom_image_preview.can_show
            ? _c("custom-team-preview", {
                attrs: {
                  image: _vm.custom_image_preview.image,
                  closePreview: function () {
                    _vm.custom_image_preview = { can_show: false, image: "" }
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.playerPopupObj && _vm.playerPopupObj.pid
            ? _c("player-popup", {
                attrs: {
                  togglePlayerPopup: _vm.togglePlayerPopup,
                  player: _vm.playerPopupObj,
                  current_match: _vm.current_match,
                  isNDTV: false,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }